import styled from "styled-components";
import { aspectRatio as ar } from "../../../../../../common/parameters";

export const StyledInputs = styled.div`
    width: 640px;
    margin-top: 24px;
    transform-origin: top center;
`;

export const LinkRow = styled.div`
    display: flex;
`;

export const ArrowWrapper = styled.div`
    display: flex;
    align-items: center;
    .i-chevron-right {
        margin: 8px 20px 0;
        font-size: 30px;
        color: ${p => p.theme.c.active};
    }
`;

export const YoutubeInputWrapper = styled.div`
    width: 300px;
    flex: 1;
`;

export const IframeWrapper = styled.div`
    margin: auto;
    width: 768px;
`;

export const TimeRow = styled.div``;

export const Time = styled.div`
    display: inline-block;
    width: 220px;
`;

export const Hour = styled.div`
    width: 42px;
    display: inline-block;
`;

export const Minute = styled.div`
    width: 50px;
    display: inline-block;
`;
export const Second = styled.div`
    width: 50px;
    display: inline-block;
`;

export const Dots = styled.div`
    display: inline-block;
    margin: 0 8px;
`;

export const Container = styled.div`
    display: flex;
    width: ${ar.width / 1.2}px;
    height: ${ar.height / 1.2}px;
    transform: scale(1.2);
    transform-origin: top left;
    color: ${p => p.theme.c.dark};
    input {
        color: ${p => p.theme.c.dark};
    }
`;

export const LeftSide = styled.div`
    flex: 1;
    padding-top: 24px;
    padding-left: 30px;
    padding-right: 30px;
`;

export const RightSide = styled.div`
    width: 640px;
    margin-right: 40px;
`;
